import React, {useState, useEffect} from 'react';
import './FieldGrid.css';
import './FieldGridField/FieldGridField.css';
import FieldGridLine from './FieldGridLine/FieldGridLine';
import { PrimaryButton, IconButton, Label, TooltipHost } from '@fluentui/react';
import FormHandler from '../../Containers/FormHandler/FormHandler';
import TranslateTag from '../../../Utils/Local/TranslateTag';

const FieldGrid = (props) => {

    const [gridLines, setGridLines] = useState([]);
    const [gridData, setGridData] = useState();
    const [gridTitles, setGridTitles] = useState([]);
    const [formStartConfig, setFormStartConfig] = useState({});

    const calloutProps = { gapSpace: 10 };
    let tooltipId = 1;

    useEffect(() => {
        const newLines = [];
        const data = [];
        const gridFields = [...props.config.GridFields]
        for (const line of gridFields) {
            line.value = undefined;
        }
        if (props.config.value === undefined || ! Array.isArray(props.config.value) || props.config.value.length === 0) {
            newLines.push({ 'line': props.config.GridFields, 'number': newLines.length+1});
            setGridData([]);
        }
        else {
            for (const value of props.config.value) { 
                const newGridField = [];
                for (const field of gridFields) {
                    const newField = {...field};
                    newGridField.push(newField);
                    if (value[field.Id] !== undefined && value[field.Id] !== null) {
                        newField.value = value[field.Id].toString();
                    }
                }
                newLines.push({ 'line': newGridField, 'number': newLines.length+1});

                const newLineData = {...value, lineNumber: newLines.length};
                data.push(newLineData);
            }
            setGridData(data);
        }
        setGridLines(newLines);

        var titles = [];
        props.config.GridFields.forEach(element => {
            let titleClass = "fieldgridfield-content";
            if (element.Width !== undefined) {
                if (element.Width === "narrow") {
                    titleClass = "fieldgridfield-narrow"
                }
                if (element.Width === "smaller") {
                    titleClass = "fieldgridfield-smaller"
                }
                if (element.Width === "small") {
                    titleClass = "fieldgridfield-small"
                }
                if (element.Width === "medium") {
                    titleClass = "fieldgridfield-medium"
                }
                if (element.Width === "wide") {
                    titleClass = "fieldgridfield-wide"
                }
                if (element.Width === "extrawide") {
                    titleClass = "fieldgridfield-extrawide"
                }
            }
            if (element.GridTitle !== undefined && element.GridTitle !== null && element.GridTitle !== "") {
                let column = { title: element.GridTitle, class: titleClass += ' fieldgrid-heading'};
                titles.push(column);
            }
        });
        setGridTitles(titles);
    }, [props.config])

    const addLine = () => {
        const newLines = [...gridLines];
        const oneLine = [];
        props.config.GridFields.forEach(elem => { oneLine.push({...elem}) });

        for (const item of oneLine) { 
            item.value = undefined;
        };

        if (gridData.length === newLines.length) {
            newLines.push({ 'line': oneLine, 'number': newLines.length+1});
            setGridLines(newLines);
        }
    }

    const openForm = (line) => {
        setFormStartConfig({
            button: {UIEvent: props.config.FormUIEvent}, 
            id: props.config.value[line-1].Id, 
            view: "specimen",
            showFullScreenButton: false,
            onSave: props.config.onSave
        })        
    }

    const removeLine = (number) => {
        const newData = gridData.filter(f => f.lineNumber !== number);
        let numberCount = 1;
        for (const line of newData) {
            line.lineNumber = numberCount;
            numberCount++;
        }

        const newLinesWithValues = [];
        for (const value of newData) { 
            const newGridField = [];
            for (const field of props.config.GridFields) {
                const newField = {...field};
                newGridField.push(newField);
                if (value[field.Id] !== undefined) {
                    newField.value = value[field.Id].toString();
                }
            }
            newLinesWithValues.push({ 'line': newGridField, 'number': value.lineNumber});
        }

        setGridLines(newLinesWithValues);
        setGridData(newData);
        sendToChangeHandler(newData);
    }

    const gridChangeHandler = (lineNumber, field, value) => {
        const data = [...gridData];
        let found = false;
        for (const line of data) {
            if (line.lineNumber === lineNumber) {
                found = true;
                line[field] = value;
            }
        }
        if (! found) {
            const newLine = { lineNumber: lineNumber};
            newLine[field] = value;
            data.push(newLine);
        }
        setGridData(data);

        sendToChangeHandler(data);

        for (const line of gridLines) {
            if (line.number === lineNumber) {
                for (const fieldInfo of line.line) {
                    if (fieldInfo.Id === field) {
                        fieldInfo.value = value;
                    }
                }
            }
        }

    }

    const sendToChangeHandler = (data) => {
        const changedData = [];
        for (const line of data) {
            const changedLine = {...line};
            delete changedLine.lineNumber;
            changedData.push(changedLine);
        }        
        props.changeHandler(undefined,changedData);
    }

    let addButton = (null);
    if (props.config.RemoveGridAddButton === undefined || ! props.config.RemoveGridAddButton) {
        addButton = <div className='fieldgrid-addbutton'>
                        <PrimaryButton text={TranslateTag("@GenAddI@", props.language)} onClick={addLine} />
                    </div>
    }
    const deleteIcon = props.config.RemoveGridDeleteButton === undefined || ! props.config.RemoveGridDeleteButton;
    const formIcon = props.config.IncludeGridFormButton;

    return (
        <React.Fragment>
            <div>
                {props.config.Label !== "" ? (
                    <div className="fieldgrid-head">
                        <Label>{props.config.Label}</Label>
                    </div>
                ) : (null)}
                {gridTitles.length > 0 ? (
                    <div className = "fieldgrid-row">
                        {gridTitles.map((column) => (
                            <div className={column.class}>
                                {column.title}
                            </div>
                        ))}
                    </div>
                ) : (null)}
                {gridLines.length > 0 ? gridLines.map((config) => (
                    <div className = "fieldgrid-row">
                        <FieldGridLine  onKeyDown={props.onKeyDown} key={config.number} lineNumber={config.number} config={config.line} changeHandler={gridChangeHandler} data={gridData}></FieldGridLine>
                        {deleteIcon && <IconButton
                            iconProps={{iconName: 'Cancel'}}
                            onClick={() => {removeLine(config.number)}}
                        />}
                        {formIcon && <TooltipHost
                                content={TranslateTag(props.config.IconText !== undefined ? props.config.IconText : "@GenOpe@", props.language)}
                                id={tooltipId++}
                                calloutProps={calloutProps}> 
                                <IconButton
                                    iconProps={{iconName: props.config.Icon !== undefined ? props.config.Icon : 'KnowledgeArticle'}}
                                    onClick={() => {openForm(config.number)}}
                                />
                        </TooltipHost>}
                    </div>
                )) : (
                    <div>
                        ----- {TranslateTag("@GenNon@", props.language)} -----
                        <br /><br />

                    </div>
                )}
            </div>
            {formIcon && <FormHandler startConfig={formStartConfig}></FormHandler>}

            {addButton}
        </React.Fragment>
    )
}

export default FieldGrid;

